import React from 'react'

import { StyledGroup } from './CardActionsStyles'

const CardActionsButtonsGroup = ({ children, ...props }) => {
  return <StyledGroup {...props}>{children}</StyledGroup>
}

export default CardActionsButtonsGroup
